import { useState } from "react";
import { getInviteFields } from "../utils";
import Form from "./Form";
import { useUserContext } from "../contexts";
import { ADMIN, MEMBER } from "../constants";

export default function InviteAdd({
  callback,
  profileType: initialProfileType,
}) {
  const { user } = useUserContext();
  const [profileType, setProfileType] = useState(initialProfileType || ADMIN);

  const fields = getInviteFields(profileType);

  function handleFieldChange(id, value) {
    if (id === "profileType") {
      setProfileType(value);
    }
  }

  // Set initial values, including responsibilityReward if member
  const initialValues = {
    family: user.family.id,
    profileType,
    ...(profileType === MEMBER ? { responsibilityReward: 10 } : {}),
  };

  return (
    <Form
      path="invites"
      fields={fields}
      submitCallback={callback}
      initialValues={initialValues}
      onChangeCallback={handleFieldChange}
    />
  );
}
